import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Feed from "@/pages/Feed";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Campaigns from "@/pages/Campaigns";
import Inbox from "@/pages/Inbox";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Positions from "@/pages/Positions";
import PositionEditor from "@/pages/PositionEditor";
import Admin from "@/pages/Admin";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-subtle text-sm">
        Caricamento…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Feed /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/profilo" element={<Protected><Profile /></Protected>} />
            <Route path="/campagne" element={<Protected><Campaigns /></Protected>} />
            <Route path="/posta" element={<Protected><Inbox /></Protected>} />
            <Route path="/opportunita/:id" element={<Protected><OpportunityDetail /></Protected>} />
            <Route path="/posizioni" element={<Protected adminOnly><Positions /></Protected>} />
            <Route path="/posizioni/nuova" element={<Protected adminOnly><PositionEditor /></Protected>} />
            <Route path="/posizioni/:id" element={<Protected adminOnly><PositionEditor /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" toastOptions={{ style: { borderRadius: "8px", border: "1px solid #E8E7E3" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
